<template>
  <header
    class="race-list-header-parts"
    :class="{
      'race-list-header-parts--show-timetable': showTimetable,
      'race-list-header-parts--for-pc': forPc,
    }"
  >
    <p class="race-list-header-parts__data">
      <span v-if="round !== 0" class="race-list-header-parts__round"> ROUND {{ round }} </span>
      <span class="race-list-header-parts__date">{{ raceDate }}</span>
    </p>
    <h3 class="race-list-header-parts__venue">{{ raceVenue }}</h3>
  </header>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import DeviceInfo from '@/util/DeviceInfo'

/**
 * レース一覧画面: 会場・レース情報 ヘッダーUIパーツ
 */
export default defineComponent({
  name: 'RaceListHeaderParts',
  props: {
    round: {
      type: Number,
      default: 1,
    },
    raceDate: {
      type: String,
      default: '',
    },
    raceVenue: {
      type: String,
      default: '',
    },
    showTimetable: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const forPc = DeviceInfo.isForPC()
    return {
      forPc,
    }
  },
})
</script>

<style lang="scss" scoped>
.race-list-header-parts {
  width: 100%;

  &__data {
    @include fontSetTextSmall();

    &::after {
      display: block;
      content: '';
      margin: 0.8em auto;
      width: 2.4em;
      height: 0.2em;
      background: $green;
    }
  }

  &__round {
    font-weight: 600;
    margin-right: 0.8em;
  }

  &__venue {
    @include fontSetTitleBold(18);

    padding: 0 16px;
  }

  &--for-pc {
    .race-list-header-parts__venue {
      padding: 0;
    }
  }

  &--show-timetable {
    &.race-list-header-parts--for-pc {
      .race-list-header-parts__data {
        font-size: 16px;
        color: #000;

        &::after {
          margin: 8px 0;
        }
      }

      .race-list-header-parts__venue {
        font-size: 30px;
        color: #000;
      }
    }
  }
}

@media screen and (max-height: $responsiveMinHeight) {
  .race-list-header-parts {
    &__data {
      &::after {
        margin: 4px auto;
      }
    }
  }
}
</style>
